var map = {
	"./but_examine.svg": "e356",
	"./homePage.svg": "fcbc",
	"./icon-Completethetask.svg": "4c50",
	"./icon-Doctorsort.svg": "1a84",
	"./icon-Inspectionpart.svg": "07a7",
	"./icon-Scanningmode.svg": "198e",
	"./icon-active.svg": "fecb4",
	"./icon-average.svg": "c82c1",
	"./icon-default-Nodata.svg": "bd32",
	"./icon-equipmenttype.svg": "59ee",
	"./icon-expert.svg": "a225",
	"./icon-home-Down.svg": "1c06",
	"./icon-home-NonconformityReport.svg": "33eb",
	"./icon-home-Qualitycontrol.svg": "3d30",
	"./icon-home-Qualitycontrolbl.svg": "a765",
	"./icon-home-Unqualifiedrate.svg": "17f1",
	"./icon-home-average.svg": "5874",
	"./icon-home-core.svg": "0266",
	"./icon-home-people.svg": "82d2",
	"./icon-home-peoplenew.svg": "aac0",
	"./icon-home-ranking.svg": "c245",
	"./icon-home-stay.svg": "de1b",
	"./icon-home-total.svg": "f88c",
	"./icon-home-unqualified.svg": "d543",
	"./icon-home-up.svg": "7615",
	"./icon-opentop.svg": "ae54",
	"./icon-region.svg": "7b8a",
	"./icon-sort-down.svg": "da50",
	"./icon-sort.svg": "1b76",
	"./icon-time.svg": "c7b9",
	"./icon-times.svg": "1de2",
	"./icon_complete.svg": "3641",
	"./icon_core_Firstdiagnosis.svg": "c84a",
	"./icon_core_frequency.svg": "a94e",
	"./icon_core_technician.svg": "604f",
	"./icon_core_toexamine.svg": "b7c7",
	"./icon_delete.svg": "f1f2",
	"./icon_edit.svg": "fdc3",
	"./icon_sort_asce.svg": "c2b7",
	"./icon_sort_desc.svg": "aad5",
	"./lab_1.svg": "0f85",
	"./lab_2.svg": "5bd2",
	"./lab_3.svg": "7972",
	"./lab_4.svg": "d941",
	"./lab_5.svg": "4507",
	"./manager-taskdetail-complete.svg": "a35f",
	"./manager-taskdetail-distribute.svg": "1907",
	"./manager-taskdetail-start.svg": "fad0",
	"./report-diagnosis.svg": "db51",
	"./report-history.svg": "fc0c",
	"./report-isrelative.svg": "7471",
	"./report-user.svg": "3448",
	"./report-wyg.svg": "80b2",
	"./report-wys.svg": "4b64",
	"./visImagecenter.svg": "1f34",
	"./visQualitycontroldoctor.svg": "2195",
	"./vispersonal.svg": "f903",
	"./vispersonalability.svg": "9068",
	"./visportiait.svg": "00d9",
	"./visregion.svg": "3b0a",
	"./visregionImage.svg": "80d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";